export const widgetId = '#springbok_chatbot_widget'
export const widgetPluginsId = '#springbok_chatbot_widget_plugins'
export const messageType = { user: 0, bot: 1 }

export const pingEndpoint = async (endpoint, successFn, failureFn = () => {}) => {
    const controller = new AbortController()
    let fetchInit = {
        method: 'GET',
        signal: controller.signal,
    }

    // timeout for if server is unresponsive:
    const timeoutId = setTimeout(() => {
        let message = 'Request timed out'
        controller.abort()
        failureFn({ message })
        return false
    }, 8000)

    try {
        let response = await fetch(endpoint, fetchInit)
        clearTimeout(timeoutId)
        let responseOK = response?.ok ?? false
        if (responseOK) {
            successFn()
        } else {
            failureFn()
        }
        return responseOK
    } catch (e) {
        clearTimeout(timeoutId)
        failureFn(e)
        return false
    }
}
